<ng-template #oiplBlockUi>
    <p-button
        [pTooltip]="
            !checkIfCanSave()
                ? ('address.save-address-first' | translate)
                : ('address.missing-data-for-save' | translate)
        "
        [loading]="isSaving"
        icon="fa fa-save"
        [label]="'address.save-address-first' | translate"
        [disabled]="checkIfCanSave()"
        (onClick)="saveToUnlockEditMode()"
    ></p-button>
</ng-template>

<blockable-div
    #oiplBlock
    [class]="'w-full'"
    [blocked]="!model?.id"
    [blockUi]="oiplBlockUi"
>
    <!-- make sure addressId is in there first render -->
    @if (model.id) {
        <app-open-item-payment-combined-list-widget
            [autoFocusSearch]="false"
            [fillHeightList]="false"
            [ofAddress]="model"
            [noBaseEdit]="true"
            [noCopy]="true"
            [noDelete]="true"
            [noAddNew]="true"
            [noSearch]="true"
            [noDebCredButtonSig]="!model.isDebitor || !model.isCreditor"
            [viewName]="'AddressOpenItemPaymentList'"
        ></app-open-item-payment-combined-list-widget>
    }
</blockable-div>
